module.exports = __webpack_public_path__ + "static/media/error.dae3b2e6.svg";